export default __webpack_public_path__ + "static/2298-0ed0317edf9fc0f3ec4430831763faec.gif";